import React, { useEffect, useState } from 'react';
export function UrgencyBar() {
  const [timeLeft, setTimeLeft] = useState('09:59');
  const [isExpired, setIsExpired] = useState(false);
  useEffect(() => {
    const minutes = 10;
    let totalSeconds = minutes * 60;
    const saved = sessionStorage.getItem('countdownEnd');
    if (saved) {
      const remaining = Math.floor((parseInt(saved) - Date.now()) / 1000);
      if (remaining > 0) totalSeconds = remaining;
    } else {
      sessionStorage.setItem('countdownEnd', (Date.now() + totalSeconds * 1000).toString());
    }
    const interval = setInterval(() => {
      if (totalSeconds <= 0) {
        clearInterval(interval);
        setIsExpired(true);
        setTimeLeft('¡EXPIRADO!');
        return;
      }
      const m = Math.floor(totalSeconds / 60).toString().padStart(2, '0');
      const s = (totalSeconds % 60).toString().padStart(2, '0');
      setTimeLeft(`${m}:${s}`);
      totalSeconds--;
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  return <div className={`fixed top-0 left-0 right-0 z-[1000] px-2 md:px-4 py-1.5 md:py-2.5 flex items-center justify-center gap-1.5 md:gap-4 text-center font-body text-[0.6rem] md:text-[0.8rem] font-semibold tracking-[0.5px] md:tracking-[1px] border-b border-gold-dark/25 ${isExpired ? 'bg-[#333]' : 'bg-gradient-to-r from-[#1a0a00] via-[#2d1500] to-[#1a0a00]'}`} role="alert" aria-live="polite" data-id="element-295">
      <span className="bg-accent-red text-white text-[0.5rem] md:text-[0.6rem] font-extrabold tracking-[1px] md:tracking-[2px] uppercase px-1.5 md:px-2.5 py-0.5 rounded-sm animate-pulse shrink-0" data-id="element-296">
        EN VIVO
      </span>
      <span className="text-text-silver truncate" data-id="element-297">
        <span className="hidden md:inline" data-id="element-298">Precio de Lanzamiento: Solo </span>
        <span className="md:hidden" data-id="element-299">Solo </span>
        <span className="text-gold font-bold" data-id="element-300">$14.94</span>
        <span className="hidden md:inline" data-id="element-301"> USD</span> — Sube a $47
      </span>
      <span className="bg-gold-soft border border-gold-dark/25 px-2 md:px-3 py-0.5 md:py-1 rounded font-display text-[0.8rem] md:text-[1.1rem] text-gold tracking-[2px] md:tracking-[3px] shrink-0" aria-label={isExpired ? 'Expirado' : `Tiempo restante: ${timeLeft}`} data-id="element-302">
        {timeLeft}
      </span>
    </div>;
}